module.exports = __webpack_public_path__ + "media/img/features/audit-log-thumb-2484df1e04b8fdc083963e631309a3c7.png";